import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  meal: {
    minWidth: 180,
    width: '100%',
    height: '100%',
    // leave space for mealNote
    position: 'relative',
    paddingBottom: 54,
  },
  mealContent: {
    padding: '12px 12px 4px 12px',
  },
  name: {
    lineHeight: '1.3',
  },
  foreignName: {
    color: '#87919D',
  },
  priceline: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    marginTop: '1em',
  },
  price: {
    flex: '1 0 auto',
  },
  quantity: {
    flex: '1 0 100px',
    alignItems: 'center',
    textAlign: 'right',
  },
  quantityDisplay: {
    padding: '0 0.5em',
  },
  quantityButton: {
    top: '-4px',
  },
  customizationsCell: {
    borderBottom: 'none',
    padding: '3px',
  },
  customizationsContainer: {
    position: 'relative',
  },
  customizationsCollapse: {
    position: 'absolute',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    background: 'linear-gradient(180deg, rgba(255,255,255,0) 75%, rgba(255,255,255,1) 100%)',
  },
  expanded: {
    display: 'none',
  },

  expandControl: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandControlOpen: {
    transform: 'rotate(180deg)',
  },
  notes: {
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    display: 'block',
    position: 'absolute',
    bottom: 0,
    width: '100%',
    padding: '0 8px',
    height: 54,
  },
  mealNote: {
    overflowX: 'hidden',
  },
}))

export default useStyles
